import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import avtar4 from '../../assets/images/user/avatar-4.jpg'
import { useProfile } from '../Context/ProfileContext';
import { imgUrl, putData } from '../Services/api';
import { toast } from 'react-toastify';

const Profile = () => {
    const { profile, setProfile, fetchProfile } = useProfile();
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile({ ...profile, [name]: value })
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setProfile((prev) => ({
            ...prev,
            profile_image: file
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setIsLoading(true)
            const formData = new FormData();
            formData.append('username', profile.username)
            formData.append('email', profile.email)
            formData.append('mobile', profile.mobile)
            formData.append('profile_image', profile.profile_image)
            const res = await putData('/auth/profile-update', formData);
            if (res.status) {
                toast.success(res.message);
                fetchProfile();
            }
        } catch (error) {
            console.log("error Profile update", error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link t0="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/users/user-list">Users</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Account Profile
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Account Profile</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body py-0">
                                    <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className="nav-link active"
                                                id="profile-tab-2"
                                                data-bs-toggle="tab"
                                                href="#profile-2"
                                                role="tab"
                                                aria-selected="true"
                                            >
                                                <i className="fas fa-file-text me-2" />
                                                Personal Details
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane show active"
                                    id="profile-2"
                                    role="tabpanel"
                                    aria-labelledby="profile-tab-2"
                                >
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h5>Personal Information</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-12 text-center mb-3">
                                                                <div className="user-upload wid-75">
                                                                    <img
                                                                        src={
                                                                            profile.profile_image
                                                                                ? typeof profile.profile_image === 'string'
                                                                                    ? `${imgUrl}${profile.profile_image}`
                                                                                    : URL.createObjectURL(profile.profile_image)
                                                                                : avtar4
                                                                        }
                                                                        alt="img"
                                                                        className="img-fluid"
                                                                    />
                                                                    <label htmlFor="uplfile" className="img-avtar-upload">
                                                                        <i className="fa fa-camera f-24 mb-1" />
                                                                        <span>Upload</span>
                                                                    </label>
                                                                    <input type="file" id="uplfile" className="d-none" onChange={handleImageChange} />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label className="form-label">User Name</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name='username'
                                                                        value={profile.username}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label className="form-label">
                                                                        Email <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="email"
                                                                        className="form-control"
                                                                        name='email'
                                                                        value={profile.email}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-12">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Mobile</label>
                                                                        <input
                                                                            className="form-control"
                                                                            name='mobile'
                                                                            value={profile.mobile}
                                                                            onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 text-end btn-page">
                                                <Link to="/" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={isLoading}>
                                                    {isLoading ? 'Updating...' : 'Update Profile'}
                                                </button >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Profile